import { Component, OnInit, Inject, Injectable } from '@angular/core';
import { DOCUMENT } from '@angular/platform-browser';
import { environment } from '../../../../environments/environment';
import { ExternalAPIS } from '../interface/http.interfaces';

export class HttpConst {

    constructor(@Inject(DOCUMENT) private document: any) { }

    static HOSTNAME = document.location.hostname;
    static PORT = document.location.port;
    static PROTOCOL = document.location.protocol;

    // static apiUrl =`${HttpConst.PROTOCOL}//${HttpConst.HOSTNAME}:${HttpConst.PORT}/svc.main/api`;

    // static apiUrl = `http://152.17.0.125/svc.main/api`; //MOD EXP(CFJC) 202010628 REQ19649 Environment apuntando a QA
    // static apiUrl = `http://localhost:56046/api`; //MOD EXP(CFJC) 202010628 REQ19649 Environment apuntando a desarrollo
    static apiUrl = "https://mafperu.com.pe/wa_portal_cliente_core/api";
  //  static apiUrl = `http://172.21.2.10/wa_portal_cliente_core/api`;

    static TIMEOUT_UNIT_OF_TIME: TimeOut_UnitOfTime.MINUTES;
    static TIMEOUT = 1;

    static LOCAL_STORAGE_KEY_TOKEN = 'objSesionTokenUsuarioLogeado';
    //INI EXP(GVASQUEZ) 20240110 - REQ37988
    //Se agrega nuevas urls para mejorar la arquitectura consumo de servicios (apis),
    //el api_bank estará pendiente de su cambio por el momento estará localhost pero no afectará al sistema.
    static ExternalAPIS: ExternalAPIS = {
      wa_renovacionSeguros: "https://portal.mafperu.com",
      wa_experiencia_midleware: "https://pisac.mafperu.com.pe",
      api_bank: "https://localhost:23603/api/BanTotal"
    };
    //FIN EXP(GVASQUEZ) 20240110 - REQ37988
  }

  export enum TimeOut_UnitOfTime {
    SECONDS = 'seconds',
    MINUTES = 'minutes',
  }
